export enum QueryEntityType {
  Clause = 'provision',
  Section = 'section',
  Field = 'field',
  Operator = 'operator',
  BoolTextSearch = 'bool_text_search',
  TextSearch = 'text_search',
  Folder = 'folder',
}
